import { useInfiniteQuery } from '@tanstack/react-query';
import { TGetAdminRolesParams } from '../../types/admin-management/admin-roles-types';
import { getAdminRoles } from '../../services/adminService';

// import { cardsService } from '../services/cards-service';

const useGetAdminRoles = (param: TGetAdminRolesParams) => {
    const {
        data,
        error,
        fetchNextPage,
        hasNextPage,
        isFetching,
        isFetchingNextPage,
        status,
        isError,
        refetch,
        isPending,
    } = useInfiniteQuery({
        queryKey: ['admin-roles', param],
        queryFn: async ({ pageParam = '' }) =>
            // getAdminRoles({ next_cursor: pageParam, ...param }),
            getAdminRoles(),
        getNextPageParam: (lastPage) => lastPage?.next_cursor,
        initialPageParam: '',
        select: (data) => data?.pages.flatMap((page) => page?.roles),
    });
    return {
        data,
        error,
        fetchNextPage,
        hasNextPage,
        isFetching,
        isFetchingNextPage,
        isLoading: isFetching,
        status,
        isError,
        refetch,
        isPending,
    };
};

export default useGetAdminRoles;
